<script>
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";
import { SkeletonComponent } from "@syncfusion/ej2-vue-notifications";
import { configStore } from "@common/configStore";
import { ddStore } from "@common/ddStore";
import { recordStore } from "@common/recordStore";
import { workflowStore } from "@common/activityStepPanel/workflowStore";
import JsonViewer from 'vue-json-viewer';
import { GenerateComponent } from "@common/activityStepPanel/GenerateComponent";

let generateIdFnc = function (type, itemIndex = 0, propIndex = 0, uniqueId) {
    const cId = this.cId.replace(" ", /_/g).toLowerCase();
    let templateId = `itemTemplate_${cId}_${itemIndex}_${propIndex}_${type}`;
    return `${templateId}_${uniqueId}`;
};
let localComponents = {};

let isExistingTemplate = (itemTemplate) => {
    let output = false;
    for (let templateId in localComponents) {
        if (localComponents[templateId] === itemTemplate) {
            output = templateId;
            break;
        }
    }
    return output;
};

let createComp = function (templateKey, type, itemIndex, titleIndex) {
    // Don't create new component when one with exact same template already exists
    // templateKey is the existing template before validating and is stored matched to stored localComponents template
    let existing = isExistingTemplate(templateKey); // returns templateKey
    if (existing) return existing;
    let validTemplate = `<div>${templateKey}</div>`;
    let uniqueId = library.getUniqueID();
    let iTemplateCmpId = !this.config?.groupItemsBy ? generateIdFnc.call(this, type, itemIndex, titleIndex, uniqueId) : generateIdFnc.call(this, type, itemIndex, titleIndex);
    let vResults = library.validateHTML(validTemplate);
    if (!vResults?.valid) {
        let errors = vResults?.results[0]?.messages;
        errors = errors.map((err) => err.message
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;'));
        validTemplate = `<div class="invalid-template">
            (Invalid Template)<br/>
            ${errors.map((message) => `${message}<br/>`)}
        </div>`;
    }
    let component = this;
    // let recordStore = this.recordStore;
    vueApp.component(iTemplateCmpId, {
        template: validTemplate,
        data() {
            return {
                templateData: {}, // A place to put custom, local, template specific settings
                // component: component,
            };
        },
        props: {
            hovered: {
                type: Boolean,
                default: false
            },
            targeted: {
                type: Boolean,
                default: false
            },
            record: {
                type: Object,
                default() {
                    return {};
                }
            },
            itemRecords: {
                type: Array,
                default() {
                    return [];
                }
            },
            index: {}
        },
        computed: {
            moment() {
                return library.getMomentObj();
            },
            actionStore() {
                return actionStore;
            },
            records() {
                return recordStore().records;
            },
            // These will be available fields to use in the itemList headerTemplate
            // example: records.vol[volId].VOL_FIRST_NAME
            // example: records.user.CLIENT_NAME
            // example: records.opp[oppId]['CA#Application_Questions/Region_0']
            volId() {
                return component.contextVolId;
            },
            user() {
                return component.user;
            },
            oppId() {
                return component.contextOppId || component.oppId;
            },
            orgId() {
                return component.contextOrgId || component.orgId;
            },
            aeId() {
                return component.contextAeId || component.aeId;
            },
            entryPointId() {
                return component.contextEntryPointId || component.entryPointId;
            },
            affId() {
                return component.computedAffId || component.affId || component.contextAffId;
            },
            schId() {
                return component.contextSchId || component.schId;
            },
            lbeId() {
                return component.contextLbeId || component.lbeId;
            },
            datasetId() {
                return component.contextDatasetId || component.datasetId;
            }
        },
        methods: {
            trimHTML(str) {
                return library.trimHTML(str);
            },
            dateDetails(dateStr, formatStr) {
                let momentDate = library.getMoment(dateStr, formatStr);
                if (!momentDate.isValid()) {
                    momentDate = library.getMoment(dateStr, 'D MMM YYYY');
                }
                if (!momentDate.isValid()) {
                    momentDate = library.getMoment(dateStr, 'MM/DD/YYYY');
                }
                return {
                    D: momentDate.format('D'),
                    MMM: momentDate.format('MMM'),
                    dddd: momentDate.format('dddd'),
                };
            },
            toggleDelay(time, property) {
                this.templateData[property] = !this.templateData[property];
                setTimeout(() => {
                    this.templateData[property] = !this.templateData[property];
                }, parseInt(time, 10));
            }
        }
    });
    // TODO also destroy these components when the itemList is destroyed
    localComponents[iTemplateCmpId] = templateKey;
    return iTemplateCmpId;
};

const runOnceActions = {
    // Put actions in only
};

// Inputs:  vol, aff, activity

const AFF_FIELDS = [
    'AFFILIATION_ID',
    // 'DETAIL_RECORD_ID',
    'AFF_REASON_ID',
    'AFF_REASON',
    'AFF_STATUS_ID',
    'AFF_STATUS',
    'AFF_START_DATE',
    'AFF_END_DATE',
    'AFF_COMPLIANCE_STATUS',
    'AFF_COMPLIANCE_STATUS_ID',
    // 'AFF_COMPLIANCE_STATUS_VERIFIER',
    // 'AFF_STATUS_VERIFIER_DATE',
    'AFF_ACTIVITY_ENTITY',
    'AFF_ACTIVITY_ENTITY_ID',
    // 'AFF_ASSIGNMENT_WORKFLOW_STATUS',
    // 'AFF_STATUS_VERIFIER',
    // 'AFF_STATUS_DATETIME',
    'AFF_COMPLETE_DATE',
    'AFF_EXPIRATION_DATE',
    'AFF_VOLUNTEER',
    'AFF_VOLUNTEER_ID',
    'PREV_STEPS',
    'NEXT_STEPS',
    'AFF_RECORDS',
    'AFF_ASSIGNMENT_ID',
    'AFF_RENEWED_AFFILIATION_ID',
    'AFF_EXPIRING_AFFILIATION_ID',
    'AFF_IS_INCLUDED',
    'AFF_IS_ENABLED',
    'AFF_IS_COMPLETED',
    'AFF_TYPE'
];
const ACTIVITY_FIELDS = [
    'ACTIVITY_ENTITY_ACTION',
    'ACTIVITY_ENTITY_ID',
    'ACTIVITY_ENTITY_MESSAGE',
    'ACTIVITY_ENTITY_TITLE',
    'ACTIVITY_TYPE_ID',
    'AE_COMPLETED_AFF_STATUS',
    'AE_COMPLETED_AFF_STATUS_ID',
    'AE_COMPLETED_BY_DEFAULT',
    'AE_COMPLETED_LOGIC_FILTER_ID',
    'AE_CSSCLASSES',
    'AE_DEFAULT_AFF_COMPLIANCE_STATUS',
    'AE_DEFAULT_AFF_COMPLIANCE_STATUS_ID',
    'AE_DEFAULT_AFF_STATUS',
    'AE_DEFAULT_AFF_STATUS_ID',
    'AE_DESCRIPTION',
    'AE_ENABLED_AFF_STATUS',
    'AE_ENABLED_AFF_STATUS_ID',
    'AE_ENABLED_BY_DEFAULT',
    'AE_ENABLED_LOGIC_FILTER_ID',
    'AE_ENABLED_SET',
    'AE_ENABLED_SET_AFF_REASON_ID',
    'AE_ENABLED_SET_AFF_START_DATE',
    'AE_COMPLETED_SET_AFF_END_DATE',
    'AE_ENABLED_SET_AFF_STATUS_ID',
    'AE_INCLUDED_AFF_STATUS',
    'AE_INCLUDED_AFF_STATUS_ID',
    'AE_INCLUDED_BY_DEFAULT',
    'AE_INCLUDED_LOGIC_FILTER_ID',
    'AE_VISIBLE_BY_DEFAULT',
    'AE_VISIBLE_AFF_STATUS_ID',
    'AE_VISIBLE_LOGIC_FILTER_ID',
    'AE_IS_COMPLIANCE',
    'AE_ONCE_AND_DONE',
    'AE_ONCE_AND_DONE_INCLUDE_FILTER_ID',
    'AE_TITLE'
];
const SHIFT_FIELDS = [
    'SS_TITLE',
    'SS_DESC',
    'SS_NOTE',
    'SS_DATE',
    'SS_START',
    'SS_FINISH_TIME',
    'SS_END_TIME',
    'SS_START_TIME',
    'SS_PICKUP_INSTR',
    'SA_SSLI_ADDRESS_1',
    'SA_SSLI_ADDRESS_2',
    'SA_SSLI_CITY',
    'SA_SSLI_COUNTRY',
    'SA_SSLI_POSTAL_CODE',
    'SA_SSLI_STATE',
    'SA_SSLI_PHONE',
    'SA_SSLI_CONTACT_PERSON',
    'SA_SSLI_CONTACT_PHONE',
    'ACTIVITY_ENTITY_ID',
    'ASSIGNMENT_ID',
    'AE_AFFILIATION_ID'
];

let compareLogicTimeout = {};
let alreadyComparedLogic = {};
let compareLogicFn = function (cId, workflowId, item, fromTimeout, affIsChangedByPrevStepComplete) {
    if (!fromTimeout) {
        if (typeof compareLogicTimeout[cId] === 'undefined') compareLogicTimeout[cId] = false;
        if (compareLogicTimeout[cId]) clearTimeout(compareLogicTimeout[cId]);
        compareLogicTimeout[cId] = setTimeout(() => {
            compareLogicFn(cId, workflowId, item, true, affIsChangedByPrevStepComplete);
        }, 5000);
        return;
    }
    let keys = ['include', 'enable', 'complete'];
    for (let j in keys) {
        let key = keys[j];
        let tmpAffID = item?.AFFILIATION_ID;
        if (!tmpAffID) return;
        if (typeof item[key + 'FrontRes'] === 'undefined' || typeof item[key + 'BackendRes'] === 'undefined') return;
        if (alreadyComparedLogic?.[cId]?.[tmpAffID]?.[key]) return;
        if (typeof alreadyComparedLogic?.[cId] === 'undefined') alreadyComparedLogic[cId] = {};
        if (typeof alreadyComparedLogic?.[cId]?.[tmpAffID] === 'undefined') alreadyComparedLogic[cId][tmpAffID] = {};
        if (typeof alreadyComparedLogic?.[cId]?.[tmpAffID]?.[key] === 'undefined') alreadyComparedLogic[cId][tmpAffID][key] = true;
        if (!!item[key + 'FrontRes'] !== !!item[key + 'BackendRes'] && !affIsChangedByPrevStepComplete) {
            let tmpErrorMmessage = "\n";
            tmpErrorMmessage += key + " backend logic result: " + (item[key + 'BackendRes'] ? 'true' : 'false') + "\n";
            tmpErrorMmessage += key + " frontend logic result: " + (item[key + 'FrontRes'] ? 'true' : 'false') + "\n";
            tmpErrorMmessage += "Volunteer ID: " + item.record.VOLUNTEER_ID + "\n";
            tmpErrorMmessage += "Affiliation ID: " + tmpAffID + "\n";
            tmpErrorMmessage += "Workflow ID: " + workflowId + "\n";
            tmpErrorMmessage += "Activity Entity ID: " + item.ACTIVITY_ENTITY_ID + "\n";
            errorHandler.handle(tmpErrorMmessage, { messageSubject: "Backend logic not equal with frontend" });
        }
    }
};

const locals = {
    formatToUI(step, relatedRecords) {
        // Mapping/Formatting Functions
        let setLogicRecords = (serverLogic, step) => {
            let output = [];
            let stepRecords = step.relatedRecords;
            if (!library.isJson(serverLogic)) return output;
            let logicObj = JSON.parse(serverLogic);
            let logicRule = logicObj['[FilterEditor::FiltersColumns]'];
            if (Array.isArray(logicRule)) {
                for (let i in logicRule) {
                    if (i === 'length') continue;
                    if (typeof logicRule[i].GRID_FIELD_NAME !== 'string') continue;
                    output[i] = { criteriaRecord: 'dynamically' };
                    // Set the perspective
                    let logicPsp = logicRule[i].FLT_SELECT_FIELD_PERSPECTIVE_ABBREV;
                    if (logicPsp === 'lbe') {
                        if (logicRule[i].LBE_TYPE === 5) logicPsp = 'waiver'; // NOSONAR
                        if (logicRule[i].LBE_TYPE === 6) logicPsp = 'training'; // NOSONAR
                    }
                    let assignmentSubRecord = logicRule[i].FLT_CLAUSE_PSP_OPTION; // Sub-record is related orgs (eg: tier 500) ie: orgKind
                    // Check for is assignment record
                    if (logicRule[i].GRID_FIELD_NAME === 'AFF_ASSIGNMENT_STATUS') {
                        output[i].recordId = stepRecords.ASSIGNMENT_ID;
                    }
                    // Check for a selected "Sub Record" from the assignment
                    else if (assignmentSubRecord && assignmentSubRecord !== 2) {
                        if (assignmentSubRecord === 1) output[i].recordId = stepRecords.ASSIGNMENT_ID;
                        else if (assignmentSubRecord === 9999) output[i].recordId = stepRecords.DETAIL_RECORD_ID; // NOSONAR
                        else if (logicPsp === 'aff') output[i].recordId = stepRecords?.ASSIGNMENT?.LINKED_AFFILIATIONS?.[assignmentSubRecord];
                        else output[i].recordId = stepRecords?.ASSIGNMENT?.LINKED_RECORDS?.[assignmentSubRecord];
                    }
                    // Otherwise link using the perspective
                    else if (logicPsp === 'vol') output[i].recordId = stepRecords?.VOLUNTEER_ID;
                    else if (logicPsp === 'aff') output[i].recordId = stepRecords?.aff?.AFFILIATION_ID;
                    else if (logicPsp === 'lbe') output[i].recordId = stepRecords?.lbe?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'waiver') output[i].recordId = stepRecords?.waiver?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'training') output[i].recordId = stepRecords?.training?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'sch') {
                        // Note: The shift fields are added in the mapped step phase
                        output[i].criteriaRecord = 'object2';
                    }
                    else if (logicPsp === 'client') {
                        output[i].criteriaRecord = 'component.ecUserProperty';
                    }
                }
            }
            return output;
        };
        let mapTemplates = (tItem, step, hideWhenComplete, hideWhenDisabled) => {
            tItem.template = tItem.TEXT;
            tItem.include = tItem.IS_DEFAULT !== 0 || !tItem.LOGIC;
            if (tItem.LOGIC) {
                let logicRecords = setLogicRecords(tItem.LOGIC, step);
                let criteria = library.parseLogicToFront(tItem.LOGIC, logicRecords);
                tItem.includeWhen = [{ criteria, resultType: 'returnCriteria' }];
            }
            tItem.hideWhenDisabled = hideWhenDisabled;
            tItem.hideWhenComplete = hideWhenComplete;
            return tItem;
        };
        let parseActionLogic = (action, step, logicType) => {
            if (action[logicType]) {
                let logicRecords = setLogicRecords(action[logicType], step);
                let criteria = library.parseLogicToFront(action[logicType], logicRecords);
                return [{ criteria, resultType: 'returnCriteria' }];
            }
            return false;
        };
        let mapActions = (action, step, hideWhenComplete, hideWhenDisabled) => {
            let tAction = library.cloneObj(action);
            tAction.label = tAction.TEXT;
            let tmpText = tAction.TEXT ? tAction.TEXT : '';
            let tmpId = tAction.ACTIVITY_ENTITY_ACTION_ID ? tAction.ACTIVITY_ENTITY_ACTION_ID : '';
            tAction.title = `${tmpText} (Action ID: ${tmpId})`;
            // Convert legacy config to standard
            // TODO: Remove this code after all configurations have been updated https://samaritan.atlassian.net/browse/DEVD-1202
            if (tAction.ACTION
                && typeof tAction.ACTION === 'object'
                && !Array.isArray(tAction.ACTION)
                && tAction.ACTION.params
            ) {
                let chainedActions = [];
                if (tAction.ACTION.params.actionChaining) {
                    chainedActions = library.cloneObj(tAction.ACTION.params.actionChaining);
                    delete tAction.ACTION.params.actionChaining;
                }
                let formattedVal = [tAction.ACTION];
                formattedVal = formattedVal.concat(chainedActions);
                tAction.action = formattedVal;
            } else tAction.action = tAction.ACTION;
            tAction.actionIcon = tAction.ACTION_ICON;
            tAction.include = !!tAction.IS_DEFAULT;
            if (tAction.CSS_CLASSES) tAction.cssClasses = tAction.CSS_CLASSES;

            tAction.includeWhen = parseActionLogic(tAction, step, 'LOGIC');
            tAction.disableWhen = parseActionLogic(tAction, step, 'DISABLE_LOGIC');

            tAction.hideWhenDisabled = hideWhenDisabled;
            tAction.hideWhenComplete = hideWhenComplete;
            return tAction;
        };
        // TODO maybe we don't need processStepLogic, and instead use AFF_IS_INCLUDED
        let processStepLogic = (step) => {
            let v1 = 1; // By Default
            let v2 = 2; // Use Logic Editor
            let v3 = 3; // Use Volunteer's Affiliation Status
            // Set include property
            let setStepState = (stepKey) => {
                // stepKey is one of: include, enable, complete
                // let partialKey = 'AE_' + stepKey.toUpperCase() + 'D'; // eg: AE_INCLUDED, AE_ENABLED, AE_COMPLETED
                let partialKey = 'AE_' + stepKey.toUpperCase() + (stepKey !== 'visible' ? 'D' : ''); // eg: AE_INCLUDED, AE_ENABLED, AE_COMPLETED, AE_VISIBLE
                let sOption = step[partialKey + '_BY_DEFAULT']; // eg: 1, 2, 3
                let affStatusKey = partialKey + '_AFF_STATUS_ID'; // eg: AE_INCLUDED_AFF_STATUS_ID
                let logicKey = partialKey + '_LOGIC_FILTER_ID'; // eg: AE_INCLUDED_LOGIC_FILTER_ID
                let criteria;
                if (!sOption || sOption === v1) {
                    criteria = {
                        rules: [{
                            field: partialKey + '_BY_DEFAULT',
                            operator: 'equal',
                            type: 'numeric',
                            value: v1,
                            criteriaRecord: 'object1' // previous step completed
                        }],
                        condition: 'and'
                    };
                } else if (sOption === v2 && step[logicKey]) {
                    let logicRecords = setLogicRecords(step[logicKey], step);
                    criteria = library.parseLogicToFront(step[logicKey], logicRecords);
                } else if (sOption === v3) {
                    let stepRecords = step.relatedRecords;
                    // Map selected status option from activity profile to logic criteria
                    if (stepRecords.aff) {
                        criteria = {
                            rules: [{
                                label: 'AFF:Status',
                                field: 'AFF_STATUS_ID',
                                operator: 'equal',
                                type: 'numeric',
                                value: step[affStatusKey],
                                psp: 'aff',
                                criteriaRecord: 'dynamically',
                                recordId: stepRecords.aff.AFFILIATION_ID
                            }],
                            condition: 'and'
                        };
                    }
                }
                // includeWhen
                // enableWhen
                // completeWhen
                if (criteria) step[stepKey + 'When'] = [{ criteria, resultType: 'returnCriteria' }];
            };
            setStepState('include');
            setStepState('visible');
            setStepState('enable');
            setStepState('complete');
        };
        step.aeId = step.ACTIVITY_ENTITY_ID;
        step.volId = step.VOLUNTEER_ID;
        step.relatedRecords = relatedRecords;
        step.stepRecords = relatedRecords;
        step.record = relatedRecords.aff;
        step.ASSIGNMENT_ID = relatedRecords.ASSIGNMENT_ID;

        // set server provided default include/enable/complete
        if (step.record) {
            // please do not use AFF_IS_ untill this feature will be tested through compareLogicFn
            // step.include = step.record.AFF_IS_INCLUDED === 'Yes';
            step.includeBackendRes = true;// step.record.AFF_IS_INCLUDED === 'Yes';
            // step.enable = step.record.AFF_IS_ENABLED === 'Yes';
            step.enableBackendRes = step.record.AFF_IS_ENABLED === 'Yes';
            // step.complete = step.record.AFF_IS_COMPLETED === 'Yes';
            step.completeBackendRes = step.record.AFF_IS_COMPLETED === 'Yes';
            step.record.ASSIGNMENT_ID = relatedRecords.ASSIGNMENT_ID;
            step.record.ASSIGNMENT = relatedRecords.ASSIGNMENT;
        }
        // convert ID
        if (!library.objIsEmpty(step.relatedRecords)) {
            for (let psp in step.relatedRecords) {
                if (typeof step.relatedRecords[psp]?.ID !== 'undefined') step[psp + 'Id'] = step.relatedRecords[psp].ID;
            }
        }

        // CSS classes
        if (typeof step.AE_CSSCLASSES !== 'undefined') step.cssClasses = step.AE_CSSCLASSES;

        if (step.AE_IS_COMPLIANCE) {
            const complianceClass = 'compliance-status-' + step?.relatedRecords?.aff?.AFF_COMPLIANCE_STATUS;
            step.cssClasses = step.cssClasses === 'undefined' ? complianceClass : step.cssClasses + ' ' + complianceClass;
        }

        // Map TITLE, DESCRIPTION, ACTIONS
        step.ecRoleVisible = !this.userStore?.coordinator?.availableActivities
            || !!this.userStore.coordinator.availableActivities.find((ca) => step.ACTIVITY_ENTITY_ID === ca.ACTIVITY_ENTITY_ID);
        if (step.ecRoleVisible) {
            if (Array.isArray(step.ACTIVITY_ENTITY_TITLE)) {
                if (!step.ACTIVITY_ENTITY_TITLE.length) step.titles = [];
                else {
                    step.titles = step.ACTIVITY_ENTITY_TITLE.map((title) => mapTemplates(title, step));
                }
            }
            // NOTE: Sometimes there are no messages
            if (Array.isArray(step.ACTIVITY_ENTITY_MESSAGE)) step.descriptions = step.ACTIVITY_ENTITY_MESSAGE.map((description) => mapTemplates(description, step, !description.SHOW_WHEN_COMPLETE, true));
            if (Array.isArray(step.ACTIVITY_ENTITY_ACTION)) step.actions = step.ACTIVITY_ENTITY_ACTION.map((action) => mapActions(action, step, !action.SHOW_WHEN_COMPLETE, true));
        }
        else {
            step.titles = [{
                template: "<div>" + ddStore.getAliasSync('WORKFLOW', 'WORKFLOW_STEP_UNAVAILABLE_WARNING') + "</div>",
                include: true
            }];
            step.descriptions = [{
                template: "<div>" + ddStore.getAliasSync('WORKFLOW', 'WORKFLOW_STEP_NOT_VISIBLE_WARNING') + "</div>",
                include: true
            }];
            step.actions = [];
            step.cssClasses += ' step-not-visible';
            step.excludeFromCount = true;
        }

        // Step Logic
        processStepLogic(step);
        return step;
    }
};

const editorSettings = {
    affiliationIdSource: {
        type: 'dropdown',
        label: 'Affiliation ID Source',
        items: [
            { text: 'From HTML Attribute "attribute-aff-id"', value: 'props' },
            { text: 'Context Affiliation', value: 'context' },
            { text: 'Find Match Using Volunteer/Activity', value: 'match' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivitySource: {
        type: 'dropdown',
        label: 'Matching Activity Source',
        items: [
            { text: 'From HTML Attribute "attribute-ae-id"', value: 'props' },
            { text: 'Context Activity', value: 'context' },
            { text: 'Specific Activity', value: 'specific' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivityId: {
        type: 'dropdown',
        label: 'Specific Related Activity',
        itemsSource: '',
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedVolSource: {
        type: 'dropdown',
        label: 'Matching Volunteer Source',
        items: [
            { text: 'from HTML Attribute "attribute-vol-id"', value: 'props' },
            { text: 'Context Volunteer', value: 'context' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    itemIconType: {
        id: 'itemIconType',
        type: 'dropdown',
        items: [
            { text: 'None', value: 'none' },
            { text: 'Number', value: 'number' },
            { text: 'Avatar Image', value: 'avatar' },
            { text: 'First Name Initial', value: 'first_initial' },
            { text: 'Last Name Initial', value: 'last_initial' },
        ],
        fields: { text: 'text', value: 'value' },
        label: 'Main Icon for Item',
        helpText: 'Specify the icon for each item.',
        default: 'number'
    },
    itemIconSize: {
        id: 'itemIconSize',
        type: 'dropdown',
        items: [
            { text: 'Small', value: 'small' },
            { text: 'Medium', value: 'medium' },
            { text: 'Large', value: 'large' },
        ],
        fields: { text: 'text', value: 'value' },
        helpText: 'Specify the size of the item icon.',
        label: 'Item Icon Size',
        default: 'small',
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'number' || this.controls.itemIconType.value === 'avatar' || this.controls.itemIconType.value === 'first_initial' || this.controls.itemIconType.value === 'last_initial'"
            }
        ],
    },
    avatarContactCardId: {
        type: 'dropdown',
        id: 'avatarContactCardId',
        itemsSource: 'componentStore.getList(true)',
        itemsFilter: 'this.item.cType === "contactCard"',
        fields: { text: 'cId', value: 'cId' },
        label: 'Avatar Contact Card ID',
        helpText: 'Choose the Contact Card to use for the Avatar Icon.',
        logic: [
            {
                record: 'self',
                criteriaRecord: 'component',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'avatar'"
            }
        ]
    },
};

const activityStepPanelConfig = {
    cId: "activityStepPanel",
    cType: "activityStepPanel",
    cTitle: "Activity Step Panel",
    cTemplate: `<div v-if="readyToRender && !ddLoading && mappedStep.visible" class="activity-step-panel" :class="[mappedStep.cssClasses, celebrateClass]">
         <div class="icon-area">
            <div class="step-number" v-if="stepNumber" @click="runCelebrateAnimation">
                <span>{{stepNumber}}</span>
            </div>
        </div>
        <div class="item-content">
            <span class="activity-id" v-if="ecUserProperty?.CLIENT_ROLE_OPTION || isDevDash">(ID: {{activityId}})</span>
            <div v-for="(title, iindex) in activeTitles" :class="title.cssClasses" :key="iindex">
                <component :is="title.templateId" :record="mappedStep.record" class="item-title"></component>
            </div>
            <div v-for="(message, iindex) in activeMessages" :class="message.cssClasses" :key="iindex">
                <component :is="message.templateId" :record="mappedStep.record"></component>
            </div>
            <!-- Standard Messages -->
            <div v-if="affRecord.AFF_EXPIRATION_DATE && affRecord.AFF_COMPLIANCE_STATUS_ID !== 3" class="expiration-status">
                <span class="expiration-flag" v-if="affRecord.AFF_COMPLIANCE_STATUS_ID === 5">
                    <span>
                        <strong>Renewal Started</strong>
                        Your current compliance expires: {{renewalExistingExpDate || affRecord.AFF_EXPIRATION_DATE}}
                    </span>
                </span>
                <span class="expiration-flag" v-if="affRecord.AFF_COMPLIANCE_STATUS_ID === 4">
                    Status: <span class="expired">Expired {{affRecord.AFF_EXPIRATION_DATE}}</span>
                </span>
                <span class="expiration-flag" v-if="affRecord.AFF_EXPIRING_AFFILIATION_ID">

                </span>
            </div>
            <div class="renewal-messages">
                <div v-if="renewing" class="renewal-in-progress-msg">
                    <i class="fa-duotone fa-solid fa-ellipsis fa-bounce fa-xl" style="--fa-primary-color: #ed135e; --fa-secondary-color: #EF7D22; --fa-secondary-opacity: 1; margin-right: 10px;"></i>
                    Renewing this step... please wait.
                </div>
                <div v-else-if="affRecord.AFF_EXPIRING_AFFILIATION_ID && affRecord.AFF_STATUS_ID === 3" class="renewal-in-progress-msg">
                    Renewal started - Expires: {{renewalExistingExpDate}}<br/>
                    <strong>Note:</strong> Use the buttons to the right to complete your renewal.
                </div>
                <div v-else-if="affRecord.AFF_COMPLIANCE_STATUS_ID === 3 && !renewalExistingExpDate" class="activity-expiration expiration-flag renew-message">
                    <i class="fa-solid fa-triangle-exclamation">{{}}</i>
                    <div class="expiration-text">
                        <strong style="display: flex">
                            Expiring Soon
                            <span v-if="affRecord.AFF_EXPIRATION_DATE"
                                  style="font-weight: normal; color: #4c4c4c; margin-left: 6px"
                            >- {{affRecord.AFF_EXPIRATION_DATE}}</span>
                        </strong>
                        <span>This task is about to expire, click the button to begin renewal.</span>
                        <span v-if="ecUserProperty?.CLIENT_ROLE_OPTION"><strong>Note:</strong> Waiting on the volunteer to begin the renewal.</span>
                    </div>
                    <button type="button" :disabled="!!ecUserProperty?.CLIENT_ROLE_OPTION"
                        class="step-action-button"
                        title="Renew"
                        @click="renewActivity"
                        ><span>Renew</span>
                    </button>
                </div>
            </div>
            <div class="activity-step-lower-messages">
                <div v-if="ecUserProperty?.CLIENT_ROLE_OPTION || isDevDash" class="info-messages coordinator-messages">
                    <div class="aff-info-text">{{affStatusText}}</div>
                    <div class="aff-info-text">{{affReasonText}}</div>
                    <div class="aff-info-text">(ID: {{affRecord.AFFILIATION_ID}})</div>
                </div>
                <div v-if="!ecUserProperty?.CLIENT_ROLE_OPTION && !isDevDash" class="info-messages volunteer-messages">
                    <button type="button" class="step-action-button" @click="showVolStepDetails = !showVolStepDetails" title="View ID">
                        <i class="fa-sharp fa-regular fa-chevron-right"></i>
                    </button>
                    <div class="aff-info-text" v-if="showVolStepDetails">(ID: {{affRecord.AFFILIATION_ID}})</div>
                </div>
                <div v-if="ecUserProperty?.CLIENT_IS_STAFF === 'Yes' || isDevDash">
                    <button type="button" @click="editActivity()" class="step-action-button im-button" title="Edit Activity">
                        <i class="fa-solid fa-wrench"></i>
                    </button>
                    <button type="button" @click="showConnections()" :hidden="editorVisible" class="step-action-button im-button" title="Connections">
                        <i class="fa-regular fa-circle-nodes"></i>
                    </button>
                </div>
                <div v-if="ecUserProperty?.CLIENT_IS_ADMIN === 'Yes' || isDevDash">
                    <button type="button" class="step-action-button" :hidden="editorVisible" title="Edit Affiliation"
                        @click="actionStore.editAffiliation({ affID: affRecord.AFFILIATION_ID, showInDialog: { AFF_STATUS: true, AFF_REASON: true, AFF_NOTE: true, AFF_START_DATE_TYPE: true, AFF_START_DATE: true, AFF_EXPIRATION_DATE_TYPE: true, AFF_EXPIRATION_DATE: true } })"
                    ><span class="h-button-text">Edit</span></button>
                </div>
                <div v-if="ecUserProperty?.CLIENT_ROLE_OPTION || isDevDash">
                    <button type="button" class="step-action-button" :hidden="editorVisible" title="View History"
                        @click="actionStore.openComponentDialog(
                            {
                                componentId: 'itemList_affiliation_history__workflow_step_' + index,
                                contextRecordIds: { affId: affRecord.AFFILIATION_ID },
                                dialogSettings: {title: 'Affiliation History'},
                                component: {
                                    volId: mappedStep.record.volId,
                                    oppId: mappedStep.record.oppId,
                                    orgId: mappedStep.record.orgId,
                                    lbeId: mappedStep.record.lbeId,
                                    schId: mappedStep.record.schId,
                                    affId: mappedStep.record.affId,
                                    aeId: mappedStep.record.aeId
                                }
                            }
                        )"
                    ><span class="h-button-text">View History</span></button>
                </div>
                <div>
                    <button type="button" class="step-action-button" :hidden="editorVisible" title="Refresh Step" @click="refresh()">
                        <span v-show="!refreshing" class="h-button-text">Refresh</span>
                        <span v-show="refreshing">Refreshing</span>
                    </button>
                    <i v-show="refreshing" class="fa-duotone fa-solid fa-ellipsis fa-bounce fa-xl" style="--fa-primary-color: #ed135e; --fa-secondary-color: #EF7D22; --fa-secondary-opacity: 1;"></i>
                </div>
            </div>
        </div>
        <div v-if="!renewing" class="item-action-area action-ctrls" :class="mappedStep.actionButtonDisplay">
            <div v-for="(action, iindex) in activeActions"
                 class="item-action-item e-icons"
                 :class="mappedStep.actionIcon"
                 :key="action.actionId"
            >
                <control :name="action.actionId"
                         :key="action.actionId"
                         :ref="action.ref || action.id"
                         :actionParams="[action, mappedStep]"
                         data-test-id="action.dataTestId"
                         :class="action.cssClasses"
                         :disabled="action.disabled"
                         :label="action.label"
                         :style="{color:action.actionTextColor, background:action.actionBackgroundColor, borderRadius:mappedStep.actionBorderRadius}"
                         :prop-config="{
                                removeOnDestroy: true,
                                hideLabel: action.hideLabel,
                                type: 'button',
                                actionIcon: action.ACTION_ICON || action.actionIcon,
                                onclick: actionClick
                         }"
                ></control>
                <p v-if="action.message">{{action.message}}</p>
            </div>
        </div>
        <div class="item-action-area complete-indicator" v-if="mappedStep.complete && !mappedStep.expiring">
            <i class="fa-solid fa-square-check">{{}}</i>
            <span class="sr-only">Complete</span>
        </div>
    </div>`,
    controls: []
};

const activityStepPanelCmp = {
    name: "activityStepPanel",
    editorSettings: editorSettings,
    props: {
        index: {
            excludeFromStore: true
        },
        record: { // Returns contextual information, such as tab info, assignment, workflow ID from User's Current View
            excludeFromStore: true
        },
        editorVisible: {
            type: Boolean,
            default: true
        },
        prevStep: { // comes from itemList
            excludeFromStore: true,
            default: false
        },
        nextStep: { // comes from itemList
            excludeFromStore: true,
            default: false
        },
    },
    data() {
        return {
            refreshing: false,
            logicParserReady: false,
            readyToRender: false,
            showVolStepDetails: false,
            viewSourceRecordData: false,
            affSubscription: false,
            activitySubscription: false,
            shiftSubscription: false,
            statusOptions: [],
            reasonOptions: [],
            titleTemplates: [],
            messageTemplates: [],
            celebrateClass: '',
            celebrationRan: false,
            initialLoading: true,
            complianceRenewalAffId: false,
            renewing: false,
            affIsChangedByPrevStepComplete: false
        };
    },
    computed: {
        volId() { // Note: this overrides global mixins
            if (this.affRecord?.volId) return this.affRecord?.volId;
            if (this.contextVolId) return this.contextVolId;
            if (this.layoutId) return this.$store.state[this.layoutId].volId;
            return 0;
        },
        stepNumber() {
            if (this.editorVisible) return this.index + 1;
            if (this.visibleIndex || this.visibleIndex === 0) return this.visibleIndex + 1;
            return false;
        },
        computedAffId() {
            // NOTE: When this changes the step links to a new affiliation while remaining in place in the UI
            return this.complianceRenewalAffId || this.affId;
        },
        isDevDash() {
            return typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'devDash';
        },
        renewalExistingExpDate() {
            let expiringAffId = this.affRecord.AFF_EXPIRING_AFFILIATION_ID;
            return expiringAffId && this.recordStore.records.aff[expiringAffId].AFF_EXPIRATION_DATE;
        },
        affRecord() {
            let affId = this.computedAffId; // comes from context record
            if (!affId) return {};
            if (!this.affSubscription) this.subscribeToAff();
            let affRecord = library.cloneObj(this.recordStore.records.aff[affId]);
            // Check for all necessary fields
            if (!affRecord.AFF_STATUS_ID || !affRecord.AFF_RECORDS) {
                return affRecord;
            } // TODO expand this to check for all necessary fields
            if (affRecord.AFF_RENEWED_AFFILIATION_ID && !this.complianceRenewalAffId) {
                this.complianceRenewalAffId = affRecord.AFF_RENEWED_AFFILIATION_ID;
                this.subscribeToAff(); // Renew our aff subscription to get new aff record fields
            }
            if (affRecord.AFF_EXPIRING_AFFILIATION_ID) this.renewing = false;
            if (!affRecord.ACTIVITY_ENTITY_ID && affRecord.AFF_RECORDS?.[8]) {
                affRecord.ACTIVITY_ENTITY_ID = Number(affRecord.AFF_RECORDS[8][0]);
            }
            let volId = affRecord.AFF_VOLUNTEER_ID;
            affRecord.VOLUNTEER_ID = volId;
            affRecord.volId = volId;
            // if (!affRecord.HISTORY) affRecord.HISTORY = {};
            // affRecord.HISTORY = Object.values(affRecord.HISTORY).reverse();
            return affRecord;
        },
        activityId() {
            return this.aeId || this.affRecord?.ACTIVITY_ENTITY_ID;
        },
        activityRecord() {
            // TODO make formatted step be part of the future workflowStore
            let activityId = this.activityId;
            if (!activityId || (!this.editorVisible && !this.computedAffId)) return {};
            // Create the subscription if it doesn't exist.
            // Note: We aren't using getSubscription to access the record
            if (!this.activitySubscription) {
                let payload = {
                    source: 'sds_getProfileField',
                    params: {
                        recordPsp: 'ae',
                        recordId: activityId,
                        fields: ACTIVITY_FIELDS,
                        params: { strictTypeResults: true }
                    },
                    updateFrequency: 0,
                };
                this.activitySubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            }
            // Use the actual record from the store for our computed
            let activityRecord = library.cloneObj(this.recordStore.records.ae[activityId]);
            // Check for all necessary fields before formatting
            // Format the activity to a Workflow Step Panel
            activityRecord.AFFILIATION_ID = this.computedAffId;
            activityRecord = locals.formatToUI(activityRecord, this.relatedRecords); // Note:  takes 3ms to process
            // Process the workflowViewer -> itemList record changes
            if (!Array.isArray(activityRecord.titles)) activityRecord.titles = [];
            if (!Array.isArray(activityRecord.descriptions)) activityRecord.descriptions = [];
            // TODO find a better way to determine if the step data is loaded
            let affIsReady = this.editorVisible || (this.affRecord.AFF_STATUS_ID && this.affRecord.AFF_RECORDS);
            if (
                activityRecord.ACTIVITY_ENTITY_ID
                && activityRecord.ACTIVITY_ENTITY_TITLE
                && activityRecord.ACTIVITY_ENTITY_MESSAGE
                && activityRecord.ACTIVITY_ENTITY_ACTION
                && activityRecord.AE_INCLUDED_BY_DEFAULT
                && activityRecord.AE_ENABLED_BY_DEFAULT
                && activityRecord.AE_COMPLETED_BY_DEFAULT
                && affIsReady
            ) activityRecord.loaded = true;
            return activityRecord;
        },
        activeTitles() {
            let baseTitle = { TEXT: this.activityRecord.AE_TITLE, template: `<div>${this.activityRecord.AE_TITLE}</div>` };
            if (!this.activityRecord.titles || !this.activityRecord.titles.length) return [baseTitle];
            let titles = library.cloneObj(this.activityRecord.titles);
            let outputTitles = [];
            titles.forEach((item, index) => {
                let {
                    template,
                    cssClasses,
                    hideWhenComplete,
                    hideWhenDisabled,
                    includeWhen
                } = item;
                let include = true;
                let prevItem = this.storedStepState.prevStep;
                let nextItem = this.storedStepState.nextStep;
                if (!this.editorVisible) {
                    if (this.mappedStep.complete && hideWhenComplete) include = false;
                    if (include && includeWhen && includeWhen.length) {
                        include = library.logicParser.call(this,
                            includeWhen,
                            item,
                            this.mappedStep.record,
                            prevItem,
                            nextItem);
                    }
                }
                if (this.editorVisible) {
                    if (includeWhen) cssClasses += ' include-when-title';
                    if (hideWhenComplete) cssClasses += ' hide-when-title';
                    if (hideWhenDisabled) cssClasses += ' disable-when-title';
                }
                if (!this.titleTemplates[index]) {
                    this.titleTemplates[index] = createComp.call(this, template, 'title', index);
                }
                outputTitles[index] = {
                    templateId: this.titleTemplates[index],
                    cssClasses,
                    include
                };
            });
            outputTitles = outputTitles.filter((item) => item.include === true);
            if (!outputTitles.length) outputTitles = [baseTitle];
            return outputTitles;
        },
        activeMessages() {
            if (!this.activityRecord.descriptions || !this.activityRecord.descriptions.length) return [];
            let items = library.cloneObj(this.activityRecord.descriptions);
            let allItems = [];
            items.forEach((item, index) => {
                let {
                    template,
                    cssClasses,
                    hideWhenComplete,
                    hideWhenDisabled,
                    includeWhen
                } = item;
                let include = true;
                let prevItem = this.storedStepState.prevStep;
                let nextItem = this.storedStepState.nextStep;
                if (!this.editorVisible) {
                    if (!this.mappedStep.enable) include = false;
                    if (this.mappedStep.complete && !hideWhenComplete) include = true;
                    if (include && includeWhen && includeWhen.length) {
                        include = library.logicParser.call(this, includeWhen,
                            item,
                            this.mappedStep.record, // This includes the merged shift data
                            prevItem,
                            nextItem);
                    }
                }
                if (this.editorVisible) {
                    if (includeWhen) cssClasses += ' include-when-message';
                    if (hideWhenComplete) cssClasses += ' hide-when-message';
                    if (hideWhenDisabled) cssClasses += ' disable-when-message';
                }
                if (!this.messageTemplates[index]) {
                    this.messageTemplates[index] = createComp.call(this, template, 'message', index);
                }
                allItems[index] = {
                    templateId: this.messageTemplates[index],
                    cssClasses,
                    include
                };
            });
            return allItems.filter((item) => item.include === true);
        },
        activeActions() {
            if (!this.activityRecord.actions || !this.activityRecord.actions.length) return [];
            let actions = library.cloneObj(this.activityRecord.actions);
            let prevItem = this.storedStepState.prevStep;
            let nextItem = this.storedStepState.nextStep;
            actions.forEach((action, index) => {
                let {
                    cssClasses,
                    hideWhenComplete,
                    hideWhenDisabled,
                    includeWhen,
                    disableWhen
                } = action;
                action.actionId = `action-item_${this.cId.replace(" ", /_/g).toLowerCase()}_${index}`;
                if (!cssClasses) action.cssClasses = '';
                let include = true;
                let disabled = false;
                if (!this.editorVisible) {
                    if (!this.mappedStep.enable && hideWhenDisabled) include = false;
                    if (this.mappedStep.complete && !hideWhenComplete) include = true;
                    if (include && includeWhen && includeWhen.length) {
                        include = library.logicParser.call(this,
                            includeWhen,
                            action,
                            this.mappedStep.record,
                            prevItem,
                            nextItem);
                    }
                    if (include && disableWhen && disableWhen.length) {
                        disabled = library.logicParser.call(this,
                            disableWhen,
                            action,
                            this.mappedStep.record,
                            prevItem,
                            nextItem);
                    }
                }
                if (this.editorVisible) {
                    if (action.includeWhen) action.cssClasses += ' include-when-button';
                    if (action.hideWhenComplete) action.cssClasses += ' hide-when-button';
                    if (action.hideWhenDisabled) action.cssClasses += ' disable-when-button';
                }
                if (typeof include === 'boolean') action.include = include;
                if (typeof disabled === 'boolean') action.disabled = disabled;
            });
            return actions.filter((action) => action.include === true);
        },
        affStatusText() {
            let statusOption = this.statusOptions.find((status) => status.value === this.affRecord.AFF_STATUS_ID);
            return statusOption?.text || '---';
        },
        affReasonText() {
            let reasonOption = this.reasonOptions.find((status) => status.value === this.affRecord.AFF_REASON_ID);
            return reasonOption?.text || '---';
        },
        workflowId() {
            return this.record?.workflowId;
        },
        assignmentId() {
            return this.record?.assignmentId;
        },
        referenceId() {
            return this.assignmentId + '_' + this.workflowId;
        },
        affRecords() {
            return this.affRecord?.AFF_RECORDS;
        },
        storedStepState() {
            let state = workflowStore().getStepState(this.assignmentId, this.workflowId, this.computedAffId);
            return state;
        },
        visibleIndex() {
            return this.storedStepState.visibleIndex;
        },
        prevAffId() {
            return this.storedStepState.prevAffId;
        },
        nextAffId() {
            return this.storedStepState.nextAffId;
        },
        relatedRecords() {
            // if (!this.affRecord?.AFF_RECORDS) return {};
            if (!this.affRecords) return {};
            let volId = this.affRecords?.[1]?.[0];
            let lbeId = this.affRecords?.[10]?.[0];
            let waiverId = this.affRecords?.[10]?.[0]; // TODO fix this connection
            let trainingId = this.affRecords?.[10]?.[0]; // TODO fix this connection
            let shiftId = this.affRecords?.[11]?.[0];
            // let assignmentId = this.record?.assignmentId;
            let assignmentId = this.assignmentId;
            // TODO update activity step message configurations so we can get rid of this block of code
            if (shiftId && !this.shiftSubscription) {
                let payload = {
                    source: 'sds_getProfileField',
                    params: {
                        recordPsp: 'sch',
                        recordId: shiftId,
                        fields: SHIFT_FIELDS,
                    },
                    updateFrequency: 60,
                };
                this.shiftSubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            }
            return {
                vol: this.recordStore.records.vol[volId],
                aff: this.affRecord,
                prevStep: this.storedStepState.prevStep, // TODO make this work with multiples
                nextStep: this.storedStepState.nextStep,
                // TODO make these work with multiples
                // TODO separate all these and get rid of relatedRecords
                lbe: this.recordStore.records.lbe[lbeId],
                waiver: this.recordStore.records.lbe[waiverId],
                training: this.recordStore.records.lbe[trainingId],
                shift: this.recordStore.records.sch[shiftId],
                assignment: this.recordStore.records.assignment[assignmentId],
                ASSIGNMENT: this.recordStore.records.assignment[assignmentId],
                ASSIGNMENT_ID: assignmentId,
                VOLUNTEER_ID: volId
            };
        },
        mappedStep() {
            let mActivity = library.cloneObj(this.activityRecord);
            if (library.objIsEmpty(mActivity)) return {}; // TODO figure out why I can't use .loaded here
            let record = library.cloneObj(this.affRecord);
            let prevItem = this.storedStepState.prevStep;
            let nextItem = this.storedStepState.nextStep;
            // Setup sub record merging
            record.stepLbe = this.relatedRecords.lbe;
            record.stepWaiver = this.relatedRecords.waiver;
            record.stepTraining = this.relatedRecords.training;
            record.stepShift = library.cloneObj(this.relatedRecords.shift);
            // merge Shift info
            let tmpShift = library.cloneObj(this.relatedRecords.shift);
            if (tmpShift) {
                delete tmpShift.ID;
                delete tmpShift.uiRecordId;
                delete tmpShift.uiRecordPsp;
                delete tmpShift.rsLastModified;
                library.mergeObj(record, tmpShift);
            }
            // Add in some standard fields to record and mActivity
            let workflowId = this.record?.workflowId; // workflowViewer provides this through props;
            record.WORKFLOW_ID = workflowId;
            mActivity.VOLUNTEER_ID = record?.AFF_VOLUNTEER_ID || mActivity.volId;
            mActivity.WORKFLOW_ID = workflowId;
            mActivity.record = record;
            let logicResult = true;
            if (mActivity.includeWhen && mActivity.includeWhen.length) {
                // need for backend and frontend logic comparison
                if (!this.editorVisible) {
                    logicResult = library.logicParser.call(this, mActivity.includeWhen, mActivity, record, prevItem, nextItem);
                }
                if (typeof logicResult === 'boolean') {
                    mActivity.include = logicResult;
                    mActivity.includeFrontRes = logicResult;
                }
            } else {
                mActivity.include = true;
            }
            // Check visibility also
            if (mActivity.include && mActivity.visibleWhen && mActivity.visibleWhen.length) {
                if (!this.editorVisible) {
                    logicResult = library.logicParser.call(this, mActivity.visibleWhen, mActivity, record, prevItem, nextItem);
                }
                if (typeof logicResult === 'boolean') {
                    mActivity.visible = logicResult;
                }
            }
            // Merge Visible and include
            mActivity.visible = mActivity.visible && mActivity.include;

            if (mActivity.completeWhen && mActivity.completeWhen.length) {
                logicResult = library.logicParser.call(this, mActivity.completeWhen, mActivity, record, prevItem, nextItem);
                if (typeof logicResult === 'boolean') {
                    mActivity.complete = logicResult;
                    mActivity.completeFrontRes = logicResult;
                }
            }
            if (mActivity.visible && !mActivity.complete && mActivity.enableWhen && mActivity.enableWhen.length) {
                if (!this.editorVisible) {
                    logicResult = library.logicParser.call(this, mActivity.enableWhen, mActivity, record, prevItem, nextItem);
                }
                if (typeof logicResult === 'boolean') {
                    mActivity.enable = logicResult;
                    mActivity.enableFrontRes = logicResult;
                }
            }
            mActivity.expiring = record?.AFF_COMPLIANCE_STATUS === 'Expiring';
            // Set not-active, enable, and complete styles
            if (mActivity.enable) mActivity.cssClasses += ' item-enabled';
            if (mActivity.expiring) mActivity.cssClasses += ' item-expiring';
            if (mActivity.complete) mActivity.cssClasses += ' item-complete';
            if (!mActivity.complete && !mActivity.enable && !mActivity.expiring) mActivity.cssClasses += ' item-inactive';
            // if editorVisible is toggled on: enable, activate, and complete all items to display all buttons and messages.
            if (this.editorVisible) {
                mActivity.cssClasses += ' editor-enabled';
                if (!mActivity.enable) mActivity.cssClasses += ' not-enabled';
                if (!mActivity.complete) mActivity.cssClasses += ' not-complete';
                mActivity.enable = true;
                mActivity.complete = true;
            }
            if (this.storedStepState.visible !== mActivity.visible || this.storedStepState.complete !== mActivity.complete) {
                // let currentStepState = {
                //     complete: output.complete,
                //     enable: output.enable,
                //     previousStepsComplete: output.previousStepsComplete,
                //     VOLUNTEER_ID: volId,
                //     visible: output.visible,
                //     AFFILIATION_ID: output.AFFILIATION_ID,
                //     ACTIVITY_ENTITY_ID: output.ACTIVITY_ENTITY_ID,
                //     AFF_STATUS: output.record?.AFF_STATUS,
                //     AFF_REASON: output.record?.AFF_REASON,
                //     ASSIGNMENT_ID: this.assignmentId,
                //     ASSIGNMENT: this.recordStore.records.assignment[this.assignmentId]
                //     // TODO add more properties including IDs
                // };
                workflowStore().addWorkflowStep(this.assignmentId, this.workflowId, mActivity, this.index);
            }
            mActivity.tabIndex = this.record.tabIndex; // used to sync up workflowViewer
            this.runOnChangeActions(mActivity);
            if (mActivity.complete && !this.celebrationRan && !this.initialLoading) {
                // this.runCelebrateAnimation();
            }
            this.emitChange(mActivity);
            compareLogicFn(this.cId, this.workflowId, mActivity, false, this.affIsChangedByPrevStepComplete);
            return mActivity;
        },
        disableStatusUpdates() {
            return this.record?.WORKFLOW_DISABLE_AUTO_STATUS_UPDATES;
        }
    },
    methods: {
        subscribeToAff() {
            if (this.affSubscription && !this.renewing) return;
            let payload = {
                source: 'sds_getProfileField',
                params: {
                    recordPsp: 'aff',
                    recordId: this.computedAffId,
                    fields: AFF_FIELDS,
                    // TODO @Dima we need to figure out something new with strictTypeResults
                    // params: { strictTypeResults: true }
                },
                updateFrequency: 20,
            };
            this.affSubscription = this.recordStore.subscribe(payload, this.cId, false, false);
        },
        renewActivity() {
            this.renewing = true;
            actionStore.renewActivity({
                currentAffId: this.affRecord.AFFILIATION_ID,
                volId: this.affRecord.AFF_VOLUNTEER_ID,
                activityId: this.activityId,
                repeatOrgId: '',
                fields: [
                    { field: 'AFF_STATUS', value: 3 },
                    { field: 'AFF_REASON', value: 503 },
                    { field: 'AFF_COMPLIANCE_STATUS', value: 5 },
                ]
            });
        },
        async refresh() {
            let record = this.mappedStep;
            this.refreshing = true;
            let isUpdateRequest = true;
            let force = true;
            this.recordStore.subscribe(false, false, isUpdateRequest, this.activitySubscription.key, false, false, force);
            await actionStore.refreshWorkflowStep({ record }); // AFF_RECORDS
            this.titleTemplates = [];
            this.messageTemplates = [];
            setTimeout(() => {
                this.refreshing = false;
            }, 1000); // Make sure the refresh is at least 1 second
        },
        emitChange(output) {
            if (this.activityRecord?.loaded && !this.emitted) {
                this.emitted = true;
                this.$emit('ready', output);
                setTimeout(() => {
                    this.emitted = false;
                }, 1000);
            }
        },
        async onCreate() {
            await library.prepLogicParsingToFront();
            this.logicParserReady = true;
            this.statusOptions = await configStore.attrListOptions("aff_status_2");
            this.reasonOptions = await configStore.attrListOptions("aff_reason_2");
            this.readyToRender = true;
        },
        async onLoad() {
            setTimeout(() => {
                this.initialLoading = false;
            }, 5000);
        },
        async editActivity() {
            let relatedRecords = {
                'wf': this.activityRecord
            };
            await actionStore.openProfile({ recordPsp: 'ae', recordId: this.activityId, relatedRecords: relatedRecords });
            this.refresh();
        },
        showConnections() {
            let _this = this;
            let relatedRecords = _this.relatedRecords;
            let dialogComponent = {
                name: 'connectionsViewer',
                data() {
                    return {
                        volId: _this.volId,
                        oppId: _this.oppId,
                        orgId: _this.orgId,
                        affId: _this.computedAffId,
                        aeId: _this.activityRecord.ID,
                        assignmentId: _this.assignmentId,
                        relatedRecords: _this.relatedRecords,
                        mappedStep: _this.mappedStep,
                        viewSourceRecordData: false,
                        recordStore: _this.recordStore
                    };
                },
                computed: {
                    schId() {
                        return this.mappedStep.record.SCHEDULE_SLOT_ID;
                    },
                    volRecord() {
                        return this.relatedRecords?.vol;
                    },
                    LINKED_RECORDS() {
                        let records = library.cloneObj(this.relatedRecords?.assignment?.LINKED_RECORDS || {});
                        delete records.OPP;
                        delete records.ORGANIZATIONS;
                        return records;
                    },
                    LINKED_AFFILIATIONS() {
                        return this.assignment?.LINKED_AFFILIATIONS || {};
                    },
                    assignment() {
                        return this.recordStore.records.assignment[this.assignmentId];
                    },
                    prevStep() {
                        return this.storedStepState?.prevStep;
                    },
                    nextStep() {
                        return this.storedStepState?.nextStep;
                    }
                },
                template: `<div class="connections-dialog">
                <div style="font-size: 360px; position: absolute; right: 5px; opacity: 0.25; color: orange;">
                    <i class="fa-light fa-circle-nodes"></i>
                </div>
                <div class="connections-dialog-inner">
                    <p style="padding-top: 5px; line-height: 1.5;">
                        <span style="font-weight: bold; font-size: 18px;">ID: {{affId}}</span> - <span style="opacity: 0.8;">Volunteer/Activity Affiliation</span><br/>
                        Activity: <span style="font-weight: bold;">{{mappedStep.AE_TITLE}}</span> <span style="opacity: 0.8;">(ID: {{aeId}})</span><br/>
                        Volunteer: <span style="font-weight: bold;">{{volRecord.VOL_FIRST_NAME}} {{volRecord.VOL_LAST_NAME}}</span> <span style="opacity: 0.8;">(ID: {{volId}})</span><br/>
                    </p>
                    <div v-if="assignment">
                        <strong>Assignment: {{assignment.ID}}</strong><br/>
                        <div v-if="assignment?.ENTRY_POINT_ORG_ID">
                            Entry Point: {{assignment?.ENTRY_POINT_ID}}?{{assignment?.ENTRY_POINT}}?
                            - (Orgs <span v-for="iOrgId in mappedStep.relatedRecords?.assignment.ENTRY_POINT_ORG_ID">{{iOrgId}}, </span>)<br/><br/>
                        </div>
                        <div v-if="oppId">Opportunity: {{oppId}}</div>
                        <div v-if="orgId">Organization Requiring: {{orgId}}</div>
                        <div v-if="LINKED_RECORDS">
                            <span style="font-weight: bold;">Hierarchy</span>
                            <ul>
                                <li v-for="(lOrgId, lTier) in LINKED_RECORDS">
                                    {{lTier}} (Program): {{lOrgId}} (affId: {{LINKED_AFFILIATIONS[lTier]}} - status)
                                </li>
                            </ul>
                        </div>
                        <span v-if="oppId">Opportunity: {{oppId}}</span><br/>
                        <span v-if="schId">Shift: {{schId}}</span><br/>
                    </div>
                    <div v-if="prevStep">
                        Previous Step<br/>
                        Affiliation: {{prevStep.AFFILIATION_ID}}<br/>
                        Activity: {{prevStep.ACTIVITY_ENTITY_ID}}<br/><br/>
                    </div>
                    <div v-if="nextStep">
                        Next Step<br/>
                        Affiliation: {{nextStep.AFFILIATION_ID}}
                        Activity: {{nextStep.ACTIVITY_ENTITY_ID}}<br/><br/>
                    </div>
                    <button type="button" @click="viewSourceRecordData = !viewSourceRecordData">view full record</button>
                    <div v-if="viewSourceRecordData">
                        <json-viewer :value="mappedStep"></json-viewer><br/><br/>
                    </div>
                    <hr/>
                    <p style="opacity: 0.8;"><strong>Info:</strong> View detailed record connections for activity step affiliations and assignments.
                    Use advanced view to see the entire data/record structure available to actions, and interpolated template values, ie: anything inside double curly braces { { } }</p>
                </div>
            </div>`,
                components: {
                    'json-viewer': JsonViewer
                }
            };
            let dialogOptions = {
                title: 'Record Connections'
            };
            library.showDialog(dialogComponent, false, false, dialogOptions);
        },
        async actionClick(event, control, actionParams) {
            if (this.editorVisible) return false;
            const [action, item] = actionParams;
            let response;
            // Perform an action
            let actionConfig = library.cloneObj(action.action);
            let prevItem = this.storedStepState.prevStep;
            let nextItem = this.storedStepState.nextStep;
            if (Array.isArray(actionConfig)) {
                let controlParams = {
                    name: control.name,
                    label: control.label
                };
                if (actionParams && actionParams?.[0]?.ACTIVITY_ENTITY_ACTION_ID) {
                    controlParams.ACTIVITY_ENTITY_ACTION_ID = actionParams[0].ACTIVITY_ENTITY_ACTION_ID;
                }
                let tmpRecord = {
                    ...item.record, prevItem, nextItem, controlParams
                };
                response = await actionStore.runChainedActions(actionConfig, tmpRecord, this);
            }
            else {
                if (actionConfig.action) {
                    let payload = library.recordSourceMapper(actionConfig.action, actionConfig.params, { ...item.record, prevItem, nextItem }, this, true);
                    if (payload) response = await actionStore[actionConfig.action](payload);
                }
            }
            return response;
        },
        runOnChangeActions() {
            if (this.editorVisible) return;
            let step = library.cloneObj(this.mappedStep);
            let record = library.cloneObj(this.affRecord);
            // Continue
            let prevItem = this.storedStepState.visibleIndex > 0 ? this.storedStepState.prevStep : { complete: true };
            let nextItem = this.storedStepState.prevStep;
            if (!step || !record || !prevItem) return;
            const currStatus = this.affRecord?.AFF_STATUS_ID;
            const newStatus = parseInt(step.AE_ENABLED_SET_AFF_STATUS_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_STATUS_ID;
            const newReason = parseInt(step.AE_ENABLED_SET_AFF_REASON_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_REASON_ID;
            const defaultStatus = parseInt(step.AE_DEFAULT_AFF_STATUS_ID, 10) > 0 && step.AE_DEFAULT_AFF_STATUS_ID;
            const newDate = typeof step.AE_ENABLED_SET_AFF_START_DATE === 'string' && step.AE_ENABLED_SET_AFF_START_DATE ? step.AE_ENABLED_SET_AFF_START_DATE : false;
            const newEndDate = typeof step.AE_COMPLETED_SET_AFF_END_DATE === 'string' && step.AE_COMPLETED_SET_AFF_END_DATE ? step.AE_COMPLETED_SET_AFF_END_DATE : false;
            const currEndDate = this.affRecord?.AFF_END_DATE;
            // Continue

            let hasStatusUpdate = !this.disableStatusUpdates
                && currStatus === defaultStatus
                && newStatus
                && (
                    (step?.AE_ENABLED_SET === 1 && prevItem.complete)
                    || (step?.AE_ENABLED_SET === 2 && this.storedStepState.previousStepsComplete)
                );
            // Note: Should expiration date only change when a status change is made?
            let hasExpDateUpdate = prevItem.complete && newEndDate && !currEndDate;

            const onChangeActions = [];
            if (hasStatusUpdate) {
                onChangeActions[0] = {
                    actions: [{
                        action: 'updateAffiliation',
                        params: {
                            affID: this.computedAffId,
                            disableResponseMessage: true,
                            isSystemAutomatedAction: true,
                            AFF_STATUS: newStatus,
                            AFF_REASON: newReason,
                            AFF_START_DATE: newDate
                        }
                    }],
                    runOnce: true
                };
            }
            if (hasExpDateUpdate) {
                onChangeActions[1] = {
                    actions: [{
                        action: 'updateAffiliation',
                        params: {
                            affID: this.computedAffId,
                            disableResponseMessage: true,
                            isSystemAutomatedAction: true,
                            AFF_END_DATE: newEndDate,
                        }
                    }],
                    runOnce: true
                };
            }
            onChangeActions.forEach((iAction, actionIndex) => {
                let actionRefId = this.referenceId + '_' + this.computedAffId + '_' + actionIndex;
                // TODO move runOnceActions flags into the workflowStepStore
                if (iAction.runOnce && runOnceActions[actionRefId] && (hasStatusUpdate || hasExpDateUpdate)) return;
                this.affIsChangedByPrevStepComplete = true;
                runOnceActions[actionRefId] = true;
                if (Array.isArray(iAction.actions)) {
                    actionStore.runChainedActions(iAction.actions, { ...record, prevItem, nextItem }, this);
                }
            });
        },
        runCelebrateAnimation() {
            this.celebrateClass = 'item-celebrating';
            this.celebrationRan = true;
            setTimeout(() => {
                this.celebrateClass = '';
            }, 2200);
        }
    },
    watch: {
        'storedStepState.previousStepsComplete': function () {
            this.runOnChangeActions();
        },
        'storedStepState.prevStep.complete': function () {
            this.runOnChangeActions();
        },
        activityId() {
            this.titleTemplates = [];
            this.messageTemplates = [];
        }
    },
    components: {
        'ejs-skeleton': SkeletonComponent
    }
};
// componentStore.initComponent puts the component into the component store, makes the component available to other vue components, and adds it to the list of component options used in editors
componentStore.initComponent(activityStepPanelCmp, activityStepPanelConfig);

export { activityStepPanelConfig, activityStepPanelCmp };
export default activityStepPanelCmp;
</script>

<style scoped>
.activity-step-panel {
    position: relative;
    background: #dedede;
    padding: 9px 9px 15px 9px;
    font-family: 'Open Sans';
    display: flex;
    margin: 5px 0;
    border-radius: 12px;
}
.activity-step-panel.item-complete {
    min-height: 60px;
    overflow: hidden;
}
.activity-step-panel.item-complete:not(.item-expiring) {
    background: #fff;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    opacity: 0.7;
}
.activity-step-panel.item-complete:hover {
    opacity: 1;
}
.activity-step-panel.item-enabled, .activity-step-panel.item-expiring {
    background: #E5F1FF;
    box-shadow: rgba(20, 20, 75, 0.25) 0px -2px 0px inset;
}
.activity-step-panel.item-complete.item-celebrating {
    background: linear-gradient(135deg, #E5F1FF 0%,#E5F1FF 27%,#ffb630 42%,#d529db 66%,#ffffff 76%,#ffffff 100%);
    background-size: 700% auto;
    animation: BackgroundGradient 2.2s ease-out infinite;
}
.activity-step-panel.editor-enabled {
    padding-left: 1.8rem;
}
@keyframes BackgroundGradient {
    0% {background-position: 0 50%; opacity: 1;}
    90% {background-position: 90% 50%; opacity: 1;}
    100% {background-position: 100% 50%; opacity: 0.7;}
}

/* styles from itemList */
.step-number {
    cursor: pointer;
    border-radius: 50%;
    font-weight: bold;
    line-height: 33px;
    text-align: center;
    grid-area: icon;
    width: 32px;
    height: 32px;
    padding-top: 0;
    margin-bottom: 10px;
    font-size: 18px;
    background: #e3f1fc;
}
.item-enabled .step-number, .item-expiring .step-number {
    background: #175c94;
    color: #fff;
}
.item-complete .step-number {
    background: #dadada;
    color: #fff;
}
.item-title {
    z-index: 3;
    font-weight: bold;
    font-size: 16px;
    margin-top: 5px;
    color: rgba(0, 0, 0, 0.8);
}
.item-content {
    flex-grow: 9;
    grid-area: content;
    padding: 0 10px 0 10px;
    text-align: left;
    display: flex;
    flex-direction: column;
    word-break: break-word;
}
.renewal-messages {
    margin-top: auto;
}
.item-content p {
    margin: 6px 0;
}
.action-ctrls {
    grid-area: action;
}
.complete-indicator {
    grid-area: complete
}
.item-action-area {
    align-items: center;
}
.item-action-item {
    text-align: right;
    margin: 5px 0 5px 10px;
}
:deep(.item-action-item button) {
    display: flex;
    border-radius: 4px;
    background: #165c94;
    color: #fff;
    margin-top: 0.125rem !important;
    padding: 0.5rem 1rem !important;
}
:deep(.item-action-item button:hover) {
    background: #357eb8;
}
/* styles from workflowViewer */
:deep(.expiration-status) {
    margin-top: 15px;
}
.renewal-in-progress-msg {
    background: #fef4eb;
    font-size: 16px;
    color: #5e3010;
    line-height: 1.5;
    display: inline-block;
    padding: 1rem;
    margin-top: 1rem;
    border-radius: 6px;
}
.expiration-flag {
    margin-right: 10px;
}
.current { color: #16a34a }
.expiring { color: #FB8432 }
.expired { color: #dc2626 }
.activity-expiration {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
@media (max-width: 620px) {
    .activity-expiration {
        flex-direction: column;
    }
}
.activity-expiration {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
.activity-expiration > .expiration-text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: #060606;
}
.activity-expiration > i {
    color: #ff3e33;
    font-size: 24px;
    animation: vibrate 30s infinite ease-in-out;
}
.activity-expiration > button {
    align-self: start;
    padding: 0.75rem 1.25rem;
    background: rgb(22, 92, 148);
    border-radius: 0.5rem;
    color: #fff;
    text-decoration: none;
    margin-top: 8px;
    margin-left: 20px;
}
.activity-expiration > button:hover {
    background: #2364f1;
}
.activity-step-lower-messages {
    margin-top: 15px;
}
.activity-step-lower-messages > div {
    display: inline-block;
}
.aff-info-text {
    display: inline-block;
    padding-right: 6px;
    padding-left: 6px;
    border-right: 1px solid #bbbbbb;
}
.aff-info-text:first-child {
    padding-left: 0;
}
.aff-info-text:last-child {
    display: inline-block;
    border-right: 0 none;
}
.editor-enabled .aff-info-text {
    display: none;
}
.volunteer-messages {
    opacity: 0.4;
}
.step-action-button {
    border: 0 none;
    transition: background .1s ease-in;
    background: rgba(255, 255, 255, .20);
    border-radius: 15px;
    color: #2b2b86;
    padding: 4px 12px;
    margin: 0 3px 0 0;
    text-decoration: underline;
}
.step-action-button:hover {
    background: rgba(0, 0, 0, .08);
    transition: all .1s ease-in-out;
}
.step-action-button.im-button {
    padding: 4px 4px;
}
.step-action-button:disabled {
    cursor: not-allowed;
    opacity: 60%;
}
.workflow-loader p {
    display: inline-block;
    line-height: 24px;
    margin: 0 0 0 15px;
    vertical-align: top;
}
.assignment-id {
    font-size: 14px;
}
.step-not-visible {
    display: none;
}
@keyframes vibrate {
    0%, 96.9% { transform: rotate(0deg) translateX(0); }
    97.0% { transform: rotate(-3deg) translateX(-2px); }
    97.1% { transform: rotate(3deg)  translateX(2px); }
    97.2% { transform: rotate(-3deg) translateX(-2px); }
    97.3% { transform: rotate(3deg)  translateX(2px); }
    97.4% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.5% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.6% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.7% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.8% { transform: rotate(-2deg) translateX(-1.5px); }
    97.9% { transform: rotate(2deg)  translateX(1.5px); }
    98.0% { transform: rotate(-2deg) translateX(-1.5px); }
    98.1% { transform: rotate(2deg)  translateX(1.5px); }
    98.2% { transform: rotate(-1.5deg) translateX(-1px); }
    98.3% { transform: rotate(1.5deg)  translateX(1px); }
    98.4% { transform: rotate(-1.5deg) translateX(-1px); }
    98.5% { transform: rotate(1.5deg)  translateX(1px); }
    98.6% { transform: rotate(-1deg) translateX(-0.8px); }
    98.7% { transform: rotate(1deg)  translateX(0.8px); }
    98.8% { transform: rotate(-0.5deg) translateX(-0.5px); }
    98.9% { transform: rotate(0.5deg)  translateX(0.5px); }
    99%, 100% { transform: rotate(0deg) translateX(0); }
}
.connections-dialog-inner {
    min-height: 400px;
}
.fa-square-check {
    color: #157a29;
    font-size: 36px;
    margin-left: 10px
}
.invalid-template {
    display: none;
}
</style>
